import React, { useEffect, useRef, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import TimeseriesGraph from './TimeseriesGraph';
import useAxiosProtect from '../../hooks/useAxiosProtect';
import HMartAlertsModal from './HMartAlertsModal';

const HMartContainer = props => {
    const [containerHeight, setContainerHeight] = useState('95vh');

    const [tabValue, setTabValue] = useState('1h');
    const [errorMessage, setErrorMessage] = useState('');
    const [data, setData] = useState([]);

    const [alertsModalOpen, setAlertsModalOpen] = useState(false);

    const axiosProtect = useAxiosProtect();

    var init = useRef(true);

    useEffect(() => {
        const updateContainerHeight = () => {
            let navbar = document.querySelector('.navbar');
            let breadcrumbNav = document.getElementsByClassName('col s12 es-breadcrumb')[0];
  
            let navbarHeight = navbar.offsetHeight + breadcrumbNav.offsetHeight;
            let windowHeight = window.innerHeight;
            let remainingHeight = windowHeight - navbarHeight;
  
            setContainerHeight(`${remainingHeight}px`);
        };
      
        updateContainerHeight();
    
        window.addEventListener('resize', updateContainerHeight);
    
        return () => {
            window.removeEventListener('resize', updateContainerHeight);
        };
    }, []);

    const fetchData = () => {
        axiosProtect.get(`/hm/hmart?timeframe=${tabValue}`).then(response => {
            setErrorMessage('');
            setData(response.data.data);

        }).catch(error => {
            setErrorMessage('An error occurred');
        })
    }

    useEffect(() => {
        fetchData();
    }, [tabValue]);

    const handleTabChange = (event, newValue) => {
        if(newValue === 'download') return;
        setTabValue(newValue);
    }

    const convertToCSV = arr => {
        const headers = ['time', 'pH'];

        const csvContent = arr.map(row => {
            // Convert timestamp to local time
            const time = new Date(row.timestamp * 1000);

            const day = ('0' + time.getDate()).slice(-2);
            const month = ('0' + (time.getMonth() + 1)).slice(-2);
            const year = time.getFullYear();
            const hours = ('0' + time.getHours()).slice(-2);
            const minutes = ('0' + time.getMinutes()).slice(-2);
            const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}`;

            const phValue = row.phvalue || '';

            return `${formattedTime},${phValue}`;
        });

        // Return the CSV content with headers
        return [headers.join(','), ...csvContent].join('\n');
    }

    const downloadCSV = () => {
        const csv = convertToCSV(data);
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', `pH_data.csv`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    return (
        <div style={{padding:`1% 2%`, backgroundColor:'#f5f5f5', height: containerHeight, overflowX:'hidden'}}>
            {alertsModalOpen && <HMartAlertsModal alertsModalOpen={alertsModalOpen} setAlertsModalOpen={setAlertsModalOpen}/>}

            <div style={{height:'100%', width:'100%', display:'flex', flexDirection:'column'}}>
                <Box sx={{width: '100%', backgroundColor:'rgba(255,255,255,0.4)'}}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'rgb(0,177,168)'
                            },
                            '& .MuiTab-textColorSecondary.Mui-selected': {
                                color: 'rgb(0,177,168)'
                            },
                            '& .MuiTab-textColorSecondary': {
                                color: 'rgb(8,114,182)'
                            },
                        }}
                        aria-label="secondary tabs example"
                        variant="fullWidth"
                    >
                        <Tab value="1h" label="1 hour" />
                        <Tab value="1d" label="1 day" />
                        <Tab value="1w" label="1 week" />
                        <Tab value="1m" label="1 month" />
                        <Tab value="3m" label="3 months" />
                        <Tab value="6m" label="6 months" />
                        <Tab value="download" style={{cursor:'default'}} label={
                            <Tooltip title="Download CSV" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                                <IconButton style={{flex:'1', borderRadius:'0'}} color="info" onClick={() => downloadCSV()}>
                                    <FileDownloadIcon/>
                                </IconButton>
                            </Tooltip>
                        }/>
                        <Tab value="download" style={{cursor:'default'}} label={
                            <Tooltip title="Manage Alerts" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                                <IconButton style={{flex:'1', borderRadius:'0'}} color="info" onClick={() => setAlertsModalOpen(true)}>
                                    <NotificationAddIcon/>
                                </IconButton>
                            </Tooltip>
                        }/>
                    </Tabs>
                </Box>

                <div style={{flex:'1', backgroundColor:'white', boxShadow:'2px 6px 12px rgb(164, 164, 164)', borderRadius:'10px'}}>
                    <TimeseriesGraph errorMessage={errorMessage} data={data} timeframe={tabValue}/>
                </div>
            </div>
        </div>
    );
}

export default HMartContainer;